import { z } from 'zod';
import { typeColorInput } from '../calendar/appointment-types.js';
const name = z.string().trim().min(2, 'Bezeichnung fehlt').max(60, 'Höchstens 60 Zeichen');
const color = typeColorInput;
export const createRelationTypeInput = z.object({ name, color: color.default('teal') });
export const updateRelationTypeInput = z
    .object({ name: name.optional(), color: color.optional() })
    .strict()
    .refine((v) => Object.values(v).some((x) => x !== undefined), 'Keine Änderung angegeben');
/** Neue Reihenfolge: alle Arten, in der Reihenfolge, in der sie stehen sollen */
export const reorderRelationTypesInput = z.object({ ids: z.array(z.uuid('Ungültige Art')).min(1).max(200) });
/** Vorschläge für neue Mandanten, die Migration 0023 legt dieselben für bestehende an */
export const DEFAULT_RELATION_TYPES = [
    { name: 'Kunde', color: 'teal' },
    { name: 'Interessent', color: 'blue' },
    { name: 'Partner', color: 'violet' },
    { name: 'Lieferant', color: 'amber' },
    { name: 'Externer Dienstleister', color: 'slate' },
];
//# sourceMappingURL=relation-types.js.map